import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { useI18n } from '../i18n';
import { ImagePickerTabs } from './ImagePicker';
export const ImagePickerModal = ({ upload, open, close, multiple }) => {
    const { $t } = useI18n();
    return (_jsxs(Modal, { open: open, onClose: close, children: [_jsx(Modal.Header, { title: $t({
                    id: 'Generics.ChooseAnImage',
                    defaultMessage: 'Choose an image',
                }) }, void 0), _jsx(Modal.Content, { children: _jsx(ImagePickerTabs, { onSelect: close, fullWidth: true, tabs: ['upload', 'link', 'unsplash'], multiple: multiple, onImageChange: upload }, void 0) }, void 0)] }, void 0));
};
//# sourceMappingURL=ImagePickerModal.js.map